import { useEffect, useState } from "react";
import {Box, Typography, FormControl, OutlinedInput, InputAdornment, InputLabel, Grid, Popper , MenuItem, ImageListItem, ImageListItemBar, ImageList, CircularProgress, Select, Button, TextField, InputBase, Stack, Tooltip} from "@mui/material"
import VideocamIcon from '@mui/icons-material/Videocam';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import './stockModal.scss';

export const PixabayVideoModal = (props) => {
  const {stockData} = props;
    const [showThumb, setShowThumb] = useState("");
    const [mousePosition, setMousePosition] = useState({x: null, y: null})
    const handleShowThumb = (e) => {
      setShowThumb(e);
    } 
    useEffect(() => {
      const updateMousePosition = (e) => {
        setMousePosition({ x: e.clientX, y: e.clientY });
      };
    
      window.addEventListener("mousemove", updateMousePosition);
      return () => window.removeEventListener("mousemove", updateMousePosition);
    }, []);

  const renderDuration = (duration) =>{
    let subtitle = "";
    const minute = Math.floor(duration / 30);
    const second = Math.round((duration - minute * 60));
    subtitle += ` ${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`
  }
  return (
    <Box>
      <Grid container spacing={{sm: 3, xs: 0.5}}>
        <Grid item lg={4} xs={12}>
          <Typography id="spring-modal-title" variant="h6" component="h2">
            Pixabay Stock Video
          </Typography>
          <Typography variant="overline" component={'p'}>
            Type: <b>{stockData?.type}</b>
          </Typography>
          <Tooltip title={stockData?.tags}>
            <Typography variant="overline" component={'p'}>
              Tags: <b>{stockData?.tags.slice(0, 40)}...</b>
            </Typography>
          </Tooltip>
          <Typography variant="overline" component={'p'}>
            Duration: <b>{stockData?.duration}</b>
          </Typography>
          <Typography variant="overline" component={'p'}>
            Views: <b>{stockData?.views}</b>
          </Typography>
          <Typography variant="overline" component={'p'}>
            Downloads: <b>{stockData?.downloads}</b>
          </Typography>
          <Typography variant="overline" component={'p'}>
            Likes: <b>{stockData?.likes}</b>
          </Typography>
          <Typography variant="overline" component={'p'}>
            Comments: <b>{stockData?.comments}</b>
          </Typography>
          <Typography variant="overline" sx={{display: 'flex', alignItems: 'center'}} component={'p'}>
            User: <Avatar src={stockData?.userImageURL} sx={{ marginX: '5px', width: 24, height: 24 }}/><b>{stockData?.user}</b>
          </Typography>
        </Grid>
        <Grid item lg={8} xs={12} alignContent={'center'}>
          <div style={{position: 'relative'}} className="stock-modal-media-wrapper">
            <video muted src={stockData?.videos.tiny.url}>
            </video>
            <div className='stockMediaBar'>
              <Stack direction='row' justifyContent='start' alignItems='center'>
                <VideocamIcon sx={{ color: 'white' }}/>
                <Typography color={'white'} variant='span'>{renderDuration(stockData?.duration)}</Typography>
              </Stack>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} className="tiny-thumbnails">
          <Stack sx={{overflow: 'hidden', borderRadius: 1}} direction={'row'} justifyContent={'center'} alignItems={'center'}>
            {[...Array(10)].map((e, i) => {
              return <img key={i} src={stockData?.videos.tiny.thumbnail} style={{height: '50px', border: '1px', objectFit:'cover', width: "10%"}} onMouseOver={handleShowThumb} onMouseLeave={() => setShowThumb("")}/>
            })}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  )
}